// Generate code from clean architecture template

import { DistrictEntity } from '../entities';
import { DistrictPayloadForm } from '../ports/payloads';
import { DistrictRepository } from '../ports/repositories';

export class CreateDistrictUsecase {
  constructor(private readonly repo: DistrictRepository) {}

  async run(payload: DistrictPayloadForm): Promise<DistrictEntity> {
    const data = this.repo.createDistrict(payload);
    return data;
  }
}
